export const MONITORING_ALARM_STATE = {
  FIRING: 'FIRING',
  OK: 'OK',
  PENDING: 'PENDING',
};


export const MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR = {
  GREATER_THAN_THRESHOLD: 'GREATER_THAN_THRESHOLD',
  GREATER_THAN_OR_EQUAL_TO_THRESHOLD: 'GREATER_THAN_OR_EQUAL_TO_THRESHOLD',
  LESS_THAN_THRESHOLD: 'LESS_THAN_THRESHOLD',
  LESS_THAN_OR_EQUAL_TO_THRESHOLD: 'LESS_THAN_OR_EQUAL_TO_THRESHOLD',
};

export const TITLE_MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR = {
  [MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR.GREATER_THAN_THRESHOLD]: 'Greater than [>]',
  [MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR.GREATER_THAN_OR_EQUAL_TO_THRESHOLD]: 'Greater than or equal [>=]',
  [MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR.LESS_THAN_THRESHOLD]: 'Less than [<]',
  [MONITORING_ALARM_EXPRESSION_COMPARISON_OPERATOR.LESS_THAN_OR_EQUAL_TO_THRESHOLD]: 'Less then or equal [<=]',
};

export const MONITORING_ALARM_EXPRESSION_METRIC = {
  INSTANCE_CPU_UTILIZATION_AVERAGE: 'INSTANCE_CPU_UTILIZATION_AVERAGE',
  INSTANCE_NETWORK_IN_BYTES: 'INSTANCE_NETWORK_IN_BYTES',
  INSTANCE_NETWORK_OUT_BYTES: 'INSTANCE_NETWORK_OUT_BYTES',
  INSTANCE_NETWORK_IN_PACKETS: 'INSTANCE_NETWORK_IN_PACKETS',
  INSTANCE_NETWORK_OUT_PACKETS: 'INSTANCE_NETWORK_OUT_PACKETS',
  INSTANCE_VOLUMES_READ_BYTES: 'INSTANCE_VOLUMES_READ_BYTES',
  INSTANCE_VOLUMES_WRITE_BYTES: 'INSTANCE_VOLUMES_WRITE_BYTES',
  INSTANCE_VOLUMES_READ_OPS: 'INSTANCE_VOLUMES_READ_OPS',
  INSTANCE_VOLUMES_WRITE_OPS: 'INSTANCE_VOLUMES_WRITE_OPS',
};

export const TITLE_MONITORING_ALARM_EXPRESSION_METRIC = {
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_CPU_UTILIZATION_AVERAGE]: 'CPU load average',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_IN_BYTES]: 'Network: Bytes/second received',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_IN_PACKETS]: 'Network: Packets/second received',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_OUT_BYTES]: 'Network: Bytes/second sent',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_OUT_PACKETS]: 'Network: Packets/second sent',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_READ_BYTES]: 'Storage: Bytes/second read',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_READ_OPS]: 'Storage: IOPs read',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_WRITE_BYTES]: 'Storage: Bytes/second written',
  [MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_WRITE_OPS]: 'Storage: IOPs write',
};

export const MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION = {
  AVERAGE: 'AVERAGE',
  DELTA: 'DELTA',
};

export const TITLE_MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION = {
  [MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION.AVERAGE]: 'Average',
  [MONITORING_ALARM_EXPRESSION_RANGEAGGREGATION.DELTA]: 'Delta',
};

export const MONITORING_ALARM_EXPRESSION_UNIT = {
  TOTAL: 'TOTAL',
  PER_SECOND: 'PER_SECOND',
  PER_MINUTE: 'PER_MINUTE',
  PER_HOUR: 'PER_HOUR',
};

export const TITLE_MONITORING_ALARM_EXPRESSION_UNIT = {
  [MONITORING_ALARM_EXPRESSION_UNIT.TOTAL]: 'Total',
  [MONITORING_ALARM_EXPRESSION_UNIT.PER_SECOND]: 'Per second',
  [MONITORING_ALARM_EXPRESSION_UNIT.PER_MINUTE]: 'Per minute',
  [MONITORING_ALARM_EXPRESSION_UNIT.PER_HOUR]: 'Per hour',
};
